@if (lorenzFormControl && lorenzFormGroup) {

	<div class="outer-wrapper"
		 [formGroup]="lorenzFormGroup">

		<div class="control-wrapper">

			@if (!lorenzFormControl.isBlocked()) {

				<select [formControl]="lorenzFormControl"

						class="control"
						[ngClass]="{
							'readonly': lorenzFormControl.isBlocked(),
							'missing-required': lorenzFormControl.isMissingRequiredValue(),
							'no-selection': !isValueSelected,
							'highlighted': lorenzFormControl.isHighlighted()
						}"
				>

					@if (hasPlaceholder) {
						<option value="">{{ placeholder | translate }}</option>
					}

					@for (selectOption of lorenzFormControlOptions(); track $index) {

						<option [value]="selectOption.value">{{ selectOption.label }}</option>

					}

				</select>

				@if (hasLayoutFloatingLabels && lorenzFormControl.hasLabel()) {
					<label class="floating-label"
						   [innerHTML]="(lorenzFormControl.getLabel() | translate) + lorenzFormControl.getRequiredAsterisk()">
					</label>
				}

			} @else {

				<input class="control"
					   [ngClass]="{
							'readonly': lorenzFormControl.isBlocked(),
							'missing-required': lorenzFormControl.isMissingRequiredValue(),
							'no-label': !lorenzFormControl.hasLabel()
				 		 }"

					   type="text"
					   [value]="lorenzFormControlValue()"
					   readonly
				>

				@if (hasLayoutFloatingLabels && lorenzFormControl.hasLabel()) {
					<label class="floating-label"
						   [innerHTML]="(lorenzFormControl.getLabel() | translate) + lorenzFormControl.getRequiredAsterisk()">
					</label>
				}
			}

			<lib-form-validity-dot [control]="lorenzFormControl" />

		</div>

		@if (showErrorMessages) {
			<div class="error">{{ lorenzFormControl.getErrors() | translate }}</div>
		}

	</div>

}
